module.exports = __webpack_public_path__ + "static/media/logo192.08c51a29.png";